// extracted by mini-css-extract-plugin
export default {"iconContainer":"C3go3u","icon":"GXPpKD","iconImg":"HTtS_O","iconWithMaxWidth100":"OBqApb","grayScale":"GXBCIe"};